import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { usePage } from '@wbk/contentful/api';
import Seo from '@/components/headers/seo';
import FullpageAnimatedLogo from '@/components/ui/Loading/FullpageAnimatedLogo';
import Error404 from '@/components/error/404';
import BookletSections from '@/components/web-sections/BookletSections';

const BookletPage = () => {
  const { lang } = useParams<{ lang: Language }>();

  const { data, isLoading } = usePage({
    lang,
    limit: 1,
    where: { slug: 'rs-guides-and-booklets' },
  });

  const [hideVideo, setHideVideo] = useState(false);

  const footer = document.getElementById('footer');
  useEffect(() => {
    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setHideVideo(entry.isIntersecting);
      },
      {
        threshold: 0.1,
      }
    );

    observer.observe(footer);

    return () => {
      observer.disconnect();
    };
  }, [footer]);

  if (isLoading) {
    return <FullpageAnimatedLogo />;
  }

  if (!data) {
    return <Error404 />;
  }

  return (
    <>
      <Seo title={data?.title} description={data?.subtitle} image={data?.background?.url} />
      <div className='relative h-full w-full pb-40'>
        {data.background?.url && (
          <video
            className={twMerge(
              'no-controls background-video pointer-events-none fixed left-1/2 top-0 h-full w-full -translate-x-1/2 object-cover opacity-30',
              hideVideo && 'opacity-0'
            )}
            src={data.background?.url}
            autoPlay
            loop
            muted
            playsInline
            style={{ zIndex: -1 }}
          />
        )}
        <div className='space-y-24'>
          {data?.sectionsCollection?.items.map((section, idx) => (
            <BookletSections
              key={section.__typename + idx}
              section={section.__typename === 'WebSection' ? section : undefined}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default BookletPage;
